import PrinterRepository from "../../../../components/repository/PrinterRepository"
import SunmiPrintService from "../SunmiPrintService"

class SunmiDevice {
    isSunmiDevice = false
    model = ''
    serialNumber = ''

    constructor(data) {
        Object.keys(data || {}).forEach(key => {
            this[key] = data[key]
        })
    }
}

class DetectSunmiDevice {
    /**
     * @type SunmiDevice
     */
    sunmiDevice = {}
    onChangeListeners = []
    addSunmiPrinter = () => {
        return PrinterRepository.getInstance().addSunmiPrinter({
            model   : this.sunmiDevice.model,
            serial_number: this.sunmiDevice.serialNumber,
        })
    }

    /**
     * Set whether to auto start print service when this device is
     * detected as SUNMI device.
     * @param {Boolean} isAutoStartStop
     */
    autoStartStopService = (isAutoStartStop) => {
        this.isAutoStartStopPrintService = isAutoStartStop
        this.#handleAutoStartPrintService()
    }

    #handleAutoStartPrintService() {
        if (this.isAutoStartStopPrintService) {
            if (this.sunmiDevice.isSunmiDevice) {
                console.log("This is sunmi device and proceed to start SunmiPrintService")
                SunmiPrintService.start()
                return
            }
            else {
                console.log("Not Sunmi device")
            }

            // Default will stop print service if above handling found no
            // matching condition and do not RETURN
            console.log("Stopping SunmiPrintService")
            SunmiPrintService.stop()
        }
    }

    /**
     * @returns SunmiDevice
     */
    getSunmiData = () => {
        let data = localStorage.getItem('sunmi_device_data')
        return new SunmiDevice(data ? JSON.parse(data) : {})
    }
    setSunmiDevice = (data = {}) => {
        this.sunmiDevice = new SunmiDevice(data)
        localStorage.setItem('sunmi_device_data', JSON.stringify(this.sunmiDevice))
        this.notifyAllListeners()
        this.#handleAutoStartPrintService()
    }
    updateSunmiData = (data) => {
        let oldData = {...this.getSunmiData(), ...(data || {})}
        this.setSunmiDevice({...oldData, ...(data || {})})
    }

    notifyListener = (listener) => {
        if (this.sunmiDevice.isSunmiDevice) {
            listener(this.sunmiDevice)
        }
        else {
            listener(null)
        }
    }

    notifyAllListeners = () => {
        this.onChangeListeners.forEach(listener => {
            this.notifyListener(listener)
        })
    }

    // We shall only init once per device
    initSunmi = () => {
        let sunmiDevice = this.getSunmiData()
        if (sunmiDevice.isSunmiDevice && sunmiDevice.model && !sunmiDevice.doneInit) {
            sunmiDevice.doneInit = true

            // Other initialization code here
        }
    }

    addOnChange = (callback) => {
        this.onChangeListeners.push(callback)
        this.notifyListener(callback)
    }
    removeOnChange = (callback) => {
        let index = this.onChangeListeners.findIndex(cb => cb === callback)
        if (index > -1) {
            this.onChangeListeners.splice(index, 1)
        }
    }
}

export default new DetectSunmiDevice()